<script lang="ts">
  import { BaseBtn, type BaseBtnProps } from '@/ui/base';

  type ProfileButtonProps = Pick<BaseBtnProps, 'label' | 'onclick'> & {
    avatar: string;
    selected?: boolean;
  };

  const { avatar, selected, ...rest }: ProfileButtonProps = $props();
</script>

<BaseBtn
  label="Profil"
  {...rest}
  class={`size-10 ${selected ? 'bg-btn-tert-S' : 'hocus:bg-btn-tert-H'}`}
>
  {avatar}
</BaseBtn>
